import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  debouncedSearch = this.debounce(() => {
    this.element.requestSubmit()
  }, 400)

  debounce(fn, delay) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => fn(...args), delay)
    }
  }
}
